export default "__VITE_ASSET__BDJAlSo0__"